/* eslint-disable @typescript-eslint/no-explicit-any */
import MuiPagination from '@mui/material/Pagination';
import {
 gridPageCountSelector,
 GridPagination,
 useGridApiContext,
 useGridSelector,
} from '@mui/x-data-grid-pro';

const PaginationComponent = ({
 count,
 page,
 rowsPerPage,
 onPageChange,
 backIconButtonProps,
 nextIconButtonProps,
 slotProps,
 ...other
}: {
 count: number;
 page: number;
 rowsPerPage: number;
 onPageChange: (event: React.ChangeEvent<unknown>, page: number) => void;
 backIconButtonProps?: any;
 nextIconButtonProps?: any;
 slotProps?: any;
 [key: string]: any;
}) => {
 const apiRef = useGridApiContext();
 const pageCount = useGridSelector(apiRef, gridPageCountSelector);

 return (
  <MuiPagination
   count={pageCount}
   page={page + 1}
   onChange={(event, p) => {
    onPageChange(event, p - 1);
   }}
   {...other}
  />
 );
};

const DataGridPagination = (props: any) => (
 <GridPagination ActionsComponent={PaginationComponent} {...props} />
);

export default DataGridPagination;
